import React from 'react';
import { Form, Flex, Input, Button, Checkbox, Select, Divider } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';

export default () => {
  return (
    <div>
        <h2>创建子账号</h2>
        <Form>
            <Form.Item
                label="姓名"
                name='username'
                rules={[{ required: true, message: '' }]}
            >
                <Input placeholder="请输入姓名" />
            </Form.Item>

            <Form.Item
                label="备注"
                name='remark'
            >
                <Input placeholder="备注" />
            </Form.Item>

            <Form.Item
                label="手机号码"
                name={'phoneNo'}
                rules={[{ required: true, message: '' }]}
            >
                <Input placeholder="" />
            </Form.Item>

            <Form.Item
                label="角色"
                name={'roleIds'}
                rules={[{ required: true, message: '' }]}
            >
                <Select options={[{label: '管理员'}]} />
            </Form.Item>

            <Form.Item
                label="适用店铺"
                name={'shopIds'}
                rules={[{ required: true, message: '' }]}
            >
                {/* <Select options={[{label: '管理员'}]} /> */}
                <Button>选择店铺</Button>
            </Form.Item>
        </Form>
        <Divider />
        <Flex gap={10} justify='center'>
            <Button size="large">
                取消
            </Button>
            <Button type="primary" size="large">
                创建
            </Button>
        </Flex>
    </div>
  );
};